<script lang="ts">
    import { ModalToken } from "@/modal-manager";
    import type InstagramPostEntity from "@apps/instagram/entities/InstagramPostEntity";

    import Clearfix from "@components/Clearfix.svelte";

    import InstagramPost from "../components/InstagramPost.svelte";
    import InstagramPostSkeleton from "../components/InstagramPostSkeleton.svelte";
    import {
        DISPLAY_MODE_HOTSPOT_TYPE,
        DISPLAY_MODE_SHOP_IT_TYPE,
    } from "../constants";

    export let postModalToken: ModalToken<{ id: number }>;
    export let posts: InstagramPostEntity[];
    export let displayMode:
        | typeof DISPLAY_MODE_SHOP_IT_TYPE
        | typeof DISPLAY_MODE_HOTSPOT_TYPE
        | null;
    export let gutter = 5;
    export let skeleton = false;
    export let skeletonPostsCount = 14;
    export let highQualityEnabled: boolean;
</script>

<div
    style={`--gw-grid-layout-gutter: ${gutter}px`}
    class="gw-ig-gallery-masonry-layout"
>
    {#if skeleton}
        {#each { length: skeletonPostsCount } as _, idx (idx)}
            <div class="gw-ig-gallery-masonry-layout__post-wrapper">
                <InstagramPostSkeleton square={true} />
            </div>
        {/each}
    {:else}
        {#each posts as post, idx (idx)}
            <div class="gw-ig-gallery-masonry-layout__post-wrapper">
                <InstagramPost
                    {post}
                    square={true}
                    {postModalToken}
                    imageObjectFit="cover"
                    {displayMode}
                    {highQualityEnabled}
                />
            </div>
        {/each}
    {/if}
    <Clearfix />
</div>

<style>
    .gw-ig-gallery-masonry-layout__post-wrapper {
        box-sizing: border-box;
        width: 50%;
        padding: var(--gw-grid-layout-gutter);
        float: left;
    }

    @media all and (min-width: 768px) {
        .gw-ig-gallery-masonry-layout__post-wrapper {
            width: 20%;
        }

        .gw-ig-gallery-masonry-layout__post-wrapper:nth-child(18n-17),
        .gw-ig-gallery-masonry-layout__post-wrapper:nth-child(18n-10),
        .gw-ig-gallery-masonry-layout__post-wrapper:nth-child(18n-3),
        .gw-ig-gallery-masonry-layout__post-wrapper:nth-child(18n-1) {
            width: 40%;
        }

        .gw-ig-gallery-masonry-layout__post-wrapper:nth-child(18n-17),
        .gw-ig-gallery-masonry-layout__post-wrapper:nth-child(18n-1) {
            float: right;
        }
    }
</style>
